import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CustomerCard from "./CustomerCard";

const DashboardCard = () => {
  const navigate = useNavigate();
  const { data, filteredData } = useSelector((state) => state.dashboard);

  const displayData =
    filteredData !== null
      ? filteredData
      : Array.isArray(data[0])
      ? [...data[0]].sort(
          (a, b) => new Date(b.createdAt || 0) - new Date(a.createdAt || 0)
        )
      : [];

  if (!displayData || displayData.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-16 px-4">
        <div className="bg-white rounded-2xl shadow-sm border border-[#D9D9D9] p-8 md:p-12 max-w-2xl w-full text-center">
          <div className="mb-6">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-20 w-20 mx-auto text-gray-300"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
              />
            </svg>
          </div>

          <h3 className="text-xl md:text-2xl font-bold text-[#454545] mb-3">
            No Calls Available
          </h3>

          <p className="text-base text-[#666] mb-6 leading-relaxed">
            You haven't subscribed to any advisors yet, or your subscribed
            advisors don't have any active calls at the moment.
          </p>

          {/* <div className="flex flex-col sm:flex-row gap-3 justify-center items-center">
            <button
              onClick={() => navigate("/advisors")}
              className="px-6 py-3 bg-primary text-white rounded-lg font-semibold hover:bg-primary/90 transition-colors w-full sm:w-auto"
            >
              Browse Advisors
            </button>
            <button
              onClick={() => window.location.reload()}
              className="px-6 py-3 bg-white text-[#454545] border border-[#D9D9D9] rounded-lg font-semibold hover:bg-gray-50 transition-colors w-full sm:w-auto"
            >
              Refresh
            </button>
          </div> */}

          <div className="mt-8 p-4 bg-blue-50 border border-blue-200 rounded-lg">
            <p className="text-sm text-blue-800">
              <span className="font-semibold">💡 Tip:</span> Subscribe to expert
              advisors.
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-4 lg:gap-5 w-full">
      {displayData.map((d, index) => (
        <CustomerCard key={d.id || index} data={d} />
      ))}
    </div>
  );
};

export default DashboardCard;
